import React from 'react';
import '../../App.css';
import Footer from '../Footer';
import './Asesoria.css';
import { useEffect } from 'react';
import { useLocation } from "react-router-dom";
import {Helmet} from "react-helmet";
import FormContent from '../FormContent';
import Fomulario from '../Formulario';
function Asesoria () {

    const { Asesoria } = useLocation();
  
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [Asesoria]);

    return (
        <>
         <Helmet>
          <meta charSet='utf-8'/>
          <title>Tekins | Asesoría Estratégica</title>
          <meta name="description" content= "Co-creamos estrategias digitales personalizadas para tu marca: diagnóstico, roadmap y acompañamiento con el equipo Tekins." />
          <meta name="robots" content= "index, follow"></meta>
          
        </Helmet>

        <div className='header'>
       
        <h1> Asesoría</h1> 
      
       
        <p> ¿Tu equipo necesita claridad para dar el siguiente paso?</p> 
        
        </div>
        <div className='contenido-ase'>
        <div className='row-ase'>
        <div className='col-ase'>
        <div className='imagen-pack-row-ase'> 
                <img class="imagen-pack-row-1-ase" 
                src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=900&q=80" 
                alt="Consultoría estratégica Tekins"/>
         </div>
        </div>
        <div className='col-ase-r'>
        <h1>Asesorías Tekins</h1>
        <h2>Esta asesoría es para ti si eres...</h2>
        <p>Un emprendedor, una startup, una empresa en etapa de expansión o un equipo in-house que necesita redefinir su estrategia digital y alinear esfuerzos con resultados medibles.</p>
        
        
        </div>

        </div>
        
        </div>
        <div className='contenido-centro'>
            <h1>¿Cómo trabajamos?</h1>
            <p>En Tekins combinamos análisis de datos, research y experiencia creativa para guiar a tu equipo. Iniciamos con un diagnóstico integral de marca, canales y audiencias para identificar brechas y oportunidades.</p>
                <p>Nuestro equipo multidisciplinario conecta estrategia, diseño y tecnología. Durante la asesoría trazamos una hoja de ruta clara, con prioridades, quick wins y métricas para validar el avance. Te acompañamos con metodologías, templates y herramientas accionables para que puedas ejecutar con confianza.</p>
        </div>
        
        <div className='contenido-ase2'>
        <div className='form-centro'>
        <div className='col-ase2'>
        <h1>Vamos por pasos</h1>
        <h2>Kick-off</h2>
        <p>1 videollamada para entender tu contexto, definir objetivos y recopilar información clave.</p>
        <h2>Sesión estratégica</h2>
        <p>1 workshop virtual de 60 minutos con especialistas de Tekins para co-crear el roadmap.</p>
        <p><br/><a target="_blank" href="https://api.whatsapp.com/send?phone=50761107470&text=Quiero%20una%20asesor%C3%ADa%20con%20Tekins"> <button className='bt' >Agenda tu asesoría</button> </a></p>
        </div>
        <div className='col-ase-r2'>
        
        
        
        </div>

        </div>
        
        </div>
    
        <div className='contenido-ase3'>
        <div className='row-ase3'>
        <div className='col-ase3'>
        <h1>¿Qué incluye? </h1>
        
        <p>            
            <ul>
            <li>Dos sesiones virtuales con consultores Tekins (kick-off + workshop).</li>
            <li>Diagnóstico ejecutivo con hallazgos y acciones priorizadas.</li>
            <li>Grabación y notas colaborativas de cada sesión.</li>
            <li>Plantillas y herramientas para implementar la estrategia.</li>
            <li>Seguimiento opcional a 30 días con un check-in rápido.</li>
            
            </ul>
            </p>
            <h3>Desde $180</h3>
        </div>
        <div className='col-ase-r3'>
        <h1>¿Qué obtendrás?</h1>
            <p>
                <ul> 
                <li>Visión clara del potencial de tu marca y sus puntos críticos.</li>
                <li>Roadmap de acciones priorizadas con responsables y tiempos estimados.</li>
                <li>Recomendaciones de canales, contenidos y automatizaciones.</li>
                <li>Métricas sugeridas para medir impacto y siguientes iteraciones.</li>
                <li>Soporte del equipo Tekins ante dudas puntuales post-sesión.</li>
               
                </ul>
            </p>
        
        
        </div>

        </div>
        <div>



            
        </div>
        
        </div>
        <h1 className='titulo-agenda'>Agenda con nosotros tu asesoría ahora</h1>
        <div className='form-centro'>
           
       

         
      
        </div>
     
          
        <Footer/>
        </>
    );
}

export default Asesoria;
